import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Box, Checkbox, TextField, Typography } from '@material-ui/core'
import _ from 'lodash'
import { useFormik } from 'formik'
import * as yup from 'yup'
import { headerStyles } from './style'
import CustomDialog from '../CustomDialog'
import { AppButton, Loader } from '..'
import * as messageTypes from '../../utils/messageTypes'
import { programService } from '../../Services'
import Close from '../../elements/icons/close'
import Check from '../../elements/icons/check'

const validationSchema = yup.object({
  siteId: yup
    .string('Enter Enphase Site Id')
    .required('Enphase Site Id is required')
    .min(2, 'Enphase Site Id must be min 2 characters')
    .max(10, 'Enphase Site Id must be max 10 characters')
    .test('maxval', 'Invalid Enphase Site ID', val => Number(val) < Math.pow(2, 31)),
})

const AutoEnrollment = (props) => {
  const classes = headerStyles()

  const [confirm, setConfirm] = useState(false)
  const [confirmPopup, setConfirmPopup] = useState(false)
  const [notifyPopup, setNotifyPopup] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState()
  const [loading, setLoading] = useState(false)

  const { showAutoEnrollment, programId } = props

  const formik = useFormik({
    initialValues: {
      siteId: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setConfirmPopup(true)
    },
    enableReinitialize: true,
  })

  const getAutoEnrollmentForm = () => (
    <Box>
      <Box className={classes.popupTitle}>Enroll new System</Box>
      <Box className={classes.formTitle} my={1}>Enter Enphase Site ID</Box>
      <form onSubmit={formik.handleSubmit}>
        <Box my={1}>
          <TextField
            fullWidth
            id="siteId"
            name="siteId"
            label="Enphase Site Id"
            type="text"
            value={formik.values.siteId}
            onInput={(e) => {
              e.target.value = e.target.value ? e.target.value.toString().replace(/\D/g, '') : ''
            }}
            onChange={formik.handleChange}
            error={formik.touched.siteId && Boolean(formik.errors.siteId)}
            helperText={formik.touched.siteId && formik.errors.siteId}
          />
        </Box>
        <AppButton className={`${classes.button} ${classes.primaryButton}`} type="submit" text="Done" />
      </form>
    </Box>
  )

  const getConfirmPopupContent = () => (
    <Box>
      <Box className={classes.popupTitle}>Please Confirm</Box>
      <Box className={classes.confirmDescription} my={2}>You are about to enroll System with <b>Enphase Site ID : {formik.values.siteId}</b> into the program.</Box>
      <Box my={2} display="flex">
        <Checkbox
          classes={{ root: classes.checkboxRoot }}
          id="confirm"
          name="confirm"
          size="small"
          checked={confirm}
          onChange={() => {
            setConfirm((confirm) => !confirm)
          }}
          color="primary"
        />
        <Box className={classes.confirmDescription}>
          I hereby accept all terms and conditions associated.
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between">
        <AppButton text="I Confirm" disabled={!confirm} onClick={() => submitAutoEnrollmentForm(formik.values)} />
      </Box>
    </Box>
  )

  const getNotifyContent = () => (
    <Box>
      <Box className={classes.notifyTitle} mx={13} mb={3}>The site is not yet enrolled into the program. Do you wish to exit?</Box>
      <Box display="flex">
        <AppButton text="Enroll Site" onClick={() => setNotifyPopup(false)} />
      </Box>
    </Box>
  )

  const getMessage = (message, messageType) => {
    return (
      <Box>
        <Box display="flex" justifyContent="center" mb={2}>
          {messageType === messageTypes.SUCCESS ? <Check /> : <Close />}
        </Box>
        <Box className={classes.messageTitle} display="flex" justifyContent="center">{messageType === messageTypes.SUCCESS ? `Site ID : ${formik.values.siteId} enrolled!` : 'Oops! System Enrollment Failed'}</Box>
        <Box className={classes.messageText} my={2}>{message}</Box>
        {messageType === messageTypes.ERROR &&
          <Box display="flex" justifyContent="center">
            <AppButton text="Retry" onClick={() => setOpen(false)} />
          </Box>
        }
      </Box>
    )
  }

  const submitAutoEnrollmentForm = (values) => {
    const { accountId, currentUser } = props
    setLoading(true)
    programService.submitAutoEnrollApplication(accountId, values.siteId, programId, currentUser.id)
      .then(enrollmentData => {
        setOpen(true)
        setMessage(`Congratulations! System with Site ID : ${values.siteId} is successfully enrolled in the program. It can now start participating in events.`)
        setMessageType(messageTypes.SUCCESS)
        setConfirmPopup(false)
        setLoading(false)
      })
      .catch(error => {
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
        setConfirmPopup(false)
        setLoading(false)
      })
  }

  return (
    <Box>
      <Loader loading={loading} />
      {showAutoEnrollment && <CustomDialog open={showAutoEnrollment} fullWidth maxWidth="xs" content={getAutoEnrollmentForm()} handleClose={() => { setNotifyPopup(true) }} />}
      {confirmPopup && <CustomDialog open={confirmPopup} fullWidth classes={{ paper: classes.customPaper }} content={getConfirmPopupContent()} handleClose={() => setConfirmPopup(false)} />}
      {notifyPopup && <CustomDialog open={notifyPopup} fullWidth classes={{ paper: classes.customPaper }} content={getNotifyContent()} handleClose={() => { setNotifyPopup(false); props.setShowAutoEnrollment(false) }} />}
      {open && message && messageType && <CustomDialog open={open} fullWidth classes={{ paper: classes.customPaper }} content={getMessage(message, messageType)} handleClose={() => { setOpen(false); props.setShowAutoEnrollment(false) }} />}
    </Box>
  )
}

const mapStateToProps = ({ auth }) => {
  const { accountId, currentUser } = auth
  return { accountId, currentUser }
}

export default connect(mapStateToProps, {})(AutoEnrollment)